
  export const TelegramIcon = ({ className = "" }: { className?: string }) => (
  <svg 
    className={className}
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.14.141-.259.259-.374.261l.213-3.053 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.136-.954l11.566-4.458c.538-.196 1.006.128.832.941z"/>
  </svg>
);

export { ReactComponent as LocationIcon } from './images/Map_Pin.svg';
export { ReactComponent as GlobeIcon } from './images/Globe.svg';
export { ReactComponent as SuitCaseIcon } from './images/Suitcase.svg';
export { ReactComponent as ActiveInputIcon } from './images/active-input-icon.svg';
export { ReactComponent as InactiveInputIcon } from './images/empty-input-icon.svg';
export { ReactComponent as ActiveCheckIcon } from './images/active-check.svg';
export { ReactComponent as InactiveCheckIcon } from './images/inactive-check.svg';
export { ReactComponent as UserVoiceIcon } from './images/User_Voice.svg';
export { ReactComponent as TaskNavIcon } from './images/tasknav.svg';
export { ReactComponent as LogoNavIcon } from './images/logonav.svg';
export { ReactComponent as UserUpdateIcon } from './images/user-updateIcon.svg';
export { ReactComponent as CommandIcon } from './images/Command.svg';
export { ReactComponent as UserAddIcon } from './images/User_Add.svg';
export { ReactComponent as UserGroupIcon } from './images/Users_Group.svg';
export { ReactComponent as FilterIcon } from './images/Filter.svg';
export { ReactComponent as ChartIcon } from './images/Chart_Bar_Vertical_01.svg';
export { ReactComponent as PaperClipIcon } from './images/Paperclip_Attechment_Tilt.svg';
export { ReactComponent as SendIcon } from './images/Arrow_Circle_Up.svg';

export { ReactComponent as AgentIcon } from './images/agentIcon.svg';
export { ReactComponent as VoiceIcon } from './images/voiceIcon.svg';
export { ReactComponent as RcdIcon } from './images/rcsIcon.svg';
export { ReactComponent as LinkedInIcon } from './images/linkedInIcon.svg';
export { ReactComponent as MailIcon } from './images/mailIcon.svg';
export { ReactComponent as WhatsappIcon } from './images/whatsappIcon.svg';
export { ReactComponent as ChatAppIcon } from './images/chatAppIcon.svg';
export { ReactComponent as SmallMailIcon } from './images/smallMailIcon.svg';
export { ReactComponent as PasswordLockIcon } from './images/password-lock.svg';
export { ReactComponent as ReloadIcon } from './images/reloadIcon.svg';
export { ReactComponent as ActiveJourneyIcon } from './images/activejourney.svg';
export { ReactComponent as WrongIcon } from './images/wrongIcon.svg';
export { ReactComponent as InactiveJourneyIcon } from './images/inactivejourney.svg';

export { ReactComponent as WhatsappIcon2 } from './images/whatsappIcon2.svg';
export { ReactComponent as SmsIcon } from './images/smsIcon2.svg';
export { ReactComponent as EmailIcon } from './images/emailIcon2.svg';
export { ReactComponent as RcsIcon2 } from './images/rcsIcon2.svg';
export { ReactComponent as LinkedInIcon2 } from './images/linkedinIcon2.svg';

export { ReactComponent as TotalRevenue } from './images/total-revenue.svg';
export { ReactComponent as ActiveDeals } from './images/active-deals.svg';
export { ReactComponent as NewAccount } from './images/user_square.svg';
export { ReactComponent as ConversionRate } from './images/conversion-rate.svg';
export { ReactComponent as MessageChatbox } from './images/message-chatbot.svg';
export { ReactComponent as ActiveLeads } from './images/active-leads.svg';
export { ReactComponent as TimeTaskIcon } from './images/time-task.svg';
export { ReactComponent as BellRingIcon } from './images/Bell_Ring.svg';

export { ReactComponent as FileUploadIcon } from './images/File_Upload.svg';
export { ReactComponent as SegmentIcon } from './images/segmentIcon.svg';
export { ReactComponent as LaunchIcon } from './images/LaunchIcon.svg';
export { ReactComponent as StarIcon } from './images/mingcute_ai-fill.svg';